import { render } from "./EditorFourCorners.vue?vue&type=template&id=110721c3"
import script from "./EditorFourCorners.vue?vue&type=script&lang=js"
export * from "./EditorFourCorners.vue?vue&type=script&lang=js"

import "./EditorFourCorners.vue?vue&type=style&index=0&id=110721c3&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__